import {
  EnumFiltroOption,
  FiltroMarker,
  FiltrosCampos,
  NotificacaoCanal,
  NotificacaoTemplate,
  StatusEnvioNotificacao,
} from "@workflow/types";
import { PessoaDTO } from "./pessoa";

/** Registro de um envio de notificação (métrica: quem recebeu, por qual canal, com qual conteúdo). */
export interface NotificacaoLogDTO {
  id: number;
  disparoId: string;
  canal: NotificacaoCanal;
  template: NotificacaoTemplate;
  status: StatusEnvioNotificacao;
  destino?: string;
  assunto?: string;
  conteudo?: string;
  contexto?: Record<string, unknown>;
  erro?: string;
  criadoEm: Date;
  /** Preenchida quando o canal reporta leitura (ex.: webhook do Inbox). */
  dataLeitura?: Date;
  destinatario: PessoaDTO;
}

type OpcaoFiltro = { id: number; nome: string };

/** Opções de filtro do histórico de notificações. */
export type NotificacaoLogFiltrosOptions = FiltrosCampos<{
  canal: EnumFiltroOption[];
  status: EnumFiltroOption[];
  template: EnumFiltroOption[];
  destinatario: OpcaoFiltro[];
  criadoEm: FiltroMarker;
}>;

/** Critério enviado pela grid (front → back). */
export interface NotificacaoLogFiltrosCriteria {
  page?: number;
  limit?: number;
  search?: string;
  sort?: string | null;
  order?: "ASC" | "DESC";

  canal?: string[];
  status?: string[];
  template?: string[];
  destinatario?: number[];
  disparoId?: string;
  criadoEm?: { from?: string; to?: string };
}

/** Períodos de métrica suportados pela tela admin. */
export const PERIODOS_RESUMO_NOTIFICACAO = [7, 15, 30] as const;
export type PeriodoResumoNotificacao = (typeof PERIODOS_RESUMO_NOTIFICACAO)[number];

/** Métricas de envio (enviadas/falhas/ignoradas/total) num período. */
export interface NotificacaoLogResumoDTO {
  totalEnviadas: number;
  totalFalhas: number;
  totalIgnoradas: number;
  totalGeral: number;
}

/** Contagem de envios agrupada por canal, status e dia, num período. */
export interface NotificacaoLogResumoPorCanalDiaDTO {
  dia: string;
  canal: NotificacaoCanal;
  status: StatusEnvioNotificacao;
  total: number;
}

/** Detalhe de um dia: envios por canal×status, motivos de falha e os destinatários que mais receberam. */
export interface NotificacaoLogDetalheDiaDTO {
  porCanalStatus: { canal: NotificacaoCanal; status: StatusEnvioNotificacao; total: number }[];
  topErros: { erro: string; total: number }[];
  topDestinatarios: { id: number; nome: string; total: number }[];
}
